export default __webpack_public_path__ + "static/media/food10.7e0fd1cf.png";